import React from 'react';

// Create a context with no initial values.
export const NumDaysContext = React.createContext();

export default NumDaysContext;
